import { arrayIsTruthy } from '@shared-helpers/array-object-helpers';
import { IForemanCatsProperties } from '@shared-interfaces/api';

import {
  ICreateProductionQuantity,
  ICreateProductionText,
  IModifyCatsRecordQuantity,
  IModifyCatsRecordText,
} from '../models/cats-outbound.model';
import { ProductionQuantity } from './productionQuantity';
import { ProductionText } from './productionText';

export class ProductionGroup {
  public id: string; // The unique identifier for this record

  constructor(
    public entities: Array<ProductionQuantity | ProductionText>,
    records: IForemanCatsProperties[],
  ) {
    this.id = entities[0]?.prdGrpID ?? '';
    if (arrayIsTruthy(records)) this.handleCatsRecordsSet(records);
  }

  handleCatsRecordsSet(catsRecords: IForemanCatsProperties[]): void {
    catsRecords.forEach((record) => {
      const found = this.entities.find((x) => x.skfNumber === record.Statkeyfig);
      this.id = record.ZprdGrpID;
      if (found) {
        found.setState(record);
      } else {
        console.error(
          `A record with SKF number ${record.Statkeyfig} existed, but did not exist on production group entity. Config may have changed after time entry.`,
        );
      }
    });
  }

  getCatRecords(): Array<ICreateProductionQuantity | ICreateProductionText | IModifyCatsRecordQuantity | IModifyCatsRecordText> {
    const records: Array<ICreateProductionQuantity | ICreateProductionText | IModifyCatsRecordQuantity | IModifyCatsRecordText> =
      [];
    this.entities.forEach((entity) => {
      const record = entity.getCatRecords();
      if (record) records.push(record);
    });
    return records;
  }

  findCounters(): string[] {
    return this.entities
      .map((productionEntity) => productionEntity.catsRecord?.Counter)
      .filter((counter): counter is string => typeof counter === 'string');
  }
}
